import(/* webpackMode: "eager" */ "/codebuild/output/src1934107898/src/apps/fanychance/src/components/layouts/PageHeader/PageHeader.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src1934107898/src/apps/fanychance/src/components/ui/Pagination/Pagination.tsx");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src1934107898/src/apps/fanychance/src/features/article/components/ArticleSmallList/ArticleSmallList.module.scss");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src1934107898/src/apps/fanychance/src/components/ui/ImageView/ImageView.module.scss");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src1934107898/src/node_modules/next/dist/client/link.js");
